import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { Privilege } from '@decorator/index';
import {
  AbTestReportService,
  ToasterLibraryService,
  VisitorService,
  ContactReportService,
  StatusService,
  StatusReportService
} from '@service/index';
import { NgxPermissionsService } from 'ngx-permissions';
import { Logger } from '@service/global.funcs';
@Component({
  selector: 'app-admissions-widget',
  templateUrl: './admissions-widget.component.html',
  styleUrls: ['./admissions-widget.component.scss']
})

// @Privilege({
//   privilege: 'visitors:can_get_visitors_reports_average_conversion_rate'
// })
export class AdmissionsWidgetComponent implements OnInit, OnChanges {
  @Input() relativeDate: any;
  @Input() campaignData: any;
  public isAdmissionsCountLoaded: boolean = false;
  public admissionsCount: number = 0;
  public criteriaArray: Array<any> = [];
  public myAccountSettings: {
    settings_name: 'addictiontreatment';
    settings_value: {
      admissions_role_id: '';
      business_dev_rep_role_id: '';
      ref_out_event_id: '';
      ref_out_status_id: '';
      vob_event_id: '';
    };
  };

  constructor(
    private contactReportService: ContactReportService,
    private toasterLibrary: ToasterLibraryService,
    private permissionService: NgxPermissionsService
  ) { }

  ngOnInit() {
    if (this.permissionService.hasPermission('visitors:can_get_visitors_reports_average_conversion_rate')) {
      this.getAdmissionsCount();
    }
  }

  ngOnChanges(changes: { [key: string]: SimpleChange }) {

    if (this.permissionService.hasPermission('visitors:can_get_visitors_reports_average_conversion_rate')) {
      if (
        (changes['relativeDate'] && !changes['relativeDate'].isFirstChange()) ||
        (changes['campaignData'] && !changes['campaignData'].isFirstChange()) ||
        (changes['criteriaArray'] && !changes['criteriaArray'].isFirstChange())
      ) {
        this.getAdmissionsCount();
      }
    }
  }

  getAdmissionsCount() {
    this.isAdmissionsCountLoaded = false;
    const criteriaArray: any = [
      {
        id: '',
        is_required: true,
        criterion: 'dateRange',
        value: {
          start_date: '',
          end_date: '',
          relative_date: this.relativeDate
        }
      },
      {
        id: '',
        is_required: true,
        criterion: 'statusSubstatus',
        value: {
          ostat_id: 2,
          ss_id: 0
        }
      }
    ];

    if (this.campaignData && this.campaignData != "") {
      criteriaArray.push({
        'id': '',
        'value': { c_id: this.campaignData },
        'criterion': 'campaign',
        'is_required': true
      });
    }

    this.contactReportService
      .getFilteredLeadsCount(criteriaArray)
      .subscribe((res: any) => {
        this.admissionsCount = parseInt(res.data.count, 10);
        this.isAdmissionsCountLoaded = true;
      });
  }
}
